import { action } from '@ember/object';
import Component from '@glimmer/component';
import {
  PrismBanner,
  PrismLoadingBar,
  PrismModal,
  PrismRadioGroup,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq, or } from 'ember-truth-helpers';
import GeneralFormFieldsCancelAndConfirm from 'lumen/components/general/form-fields/cancel-and-confirm';
import {
  PERMISSION_VALUES,
  type PermissionValue,
} from 'lumen/utils/central-mapping-constants';

interface SettingsCentralMappingModalsModalMappingPermissionsSignature {
  Args: {
    initialPermission: PermissionValue;
    isLoading: boolean;
    onChangePermission: (value: PermissionValue) => void;
    onClose: () => void;
    onSave: () => void;
    selectedPermission: PermissionValue;
  };
}

export default class SettingsCentralMappingModalsModalMappingPermissions extends Component<SettingsCentralMappingModalsModalMappingPermissionsSignature> {
  @action
  onChangePermission(event: Event): void {
    const value = (event.target as HTMLInputElement)?.value as PermissionValue;
    this.args.onChangePermission(value);
  }

  <template>
    <PrismModal
      @onClose={{@onClose}}
      @title={{t "settings.central_mapping.permissions.modal.title"}}
      data-test-id="mapping-permissions-modal"
    >
      <div class="modal--small modal--padded settings-modal__content">
        {{#if @isLoading}}
          <PrismLoadingBar />
        {{/if}}

        <p class="settings-modal__text paragraph-300--regular">
          {{t "settings.central_mapping.permissions.modal.description"}}
        </p>

        <div class="mt-400 mb-400">
          <PrismBanner
            @bannerMessage={{t
              "settings.central_mapping.permissions.modal.info_banner"
            }}
            @bannerStyle="info"
            data-test-id="mapping-permissions-info-banner"
          />
        </div>

        <PrismRadioGroup
          @name="mapping-permissions-radio-group"
          @onChange={{this.onChangePermission}}
          @value={{@selectedPermission}}
          as |RadioGroup|
        >
          <RadioGroup.input @value={{PERMISSION_VALUES.RESTRICT}}>
            {{t "settings.central_mapping.permissions.modal.option_restrict"}}
          </RadioGroup.input>
          <RadioGroup.input @value={{PERMISSION_VALUES.ALLOW}}>
            {{t "settings.central_mapping.permissions.modal.option_allow"}}
          </RadioGroup.input>
        </PrismRadioGroup>
      </div>

      <div class="settings-modal__footer">
        <GeneralFormFieldsCancelAndConfirm
          @cancel={{@onClose}}
          @confirm={{@onSave}}
          @isConfirmDisabled={{or
            @isLoading
            (eq @selectedPermission @initialPermission)
          }}
          @isConfirmLoading={{@isLoading}}
        />
      </div>
    </PrismModal>
  </template>
}
